module.exports = __webpack_public_path__ + "static/media/emedica_logo.938e7f82.png";